import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatNameLength',
    standalone: false
})
export class FormatNameLengthPipe implements PipeTransform {
   transform(name: string, length: number): string {
      if (!name || length == null || length < 0) {
         return '';
      }
      if (name.length > length) {
         return name.substring(0, length) + '...';
      }
      return name;
   }
}
